import Helpers from '../helpers/helpers';

import './import/js/jquery.fancybox.js';
import './import/img/cursor-zoomin.svg';
import './import/img/cursor-zoomout.svg';
import './import/img/play.png';

import './lightbox.scss';

export class Lightbox {
    constructor() {
        this.hashCheck();

        // Bind onInit event
        $(document).on('onInit.fb', this.onInit);
        // Bind beforeClose event
        $(document).on('beforeClose.fb', this.beforeClose);
        // Bind onComplete event
        $(document).on('onComplete.fb', this.onComplete);
    }

    hashCheck(): void {
        if (window.location.hash && window.location.hash !== '#360') {
            if ($(document).find(window.location.hash).length && ! $(document).find(window.location.hash).hasClass('section__title')) {
                // Just in case trigger reservation modal close event
                $(document).trigger('enhance.reservationModalClose');

                this.triggerLightbox(window.location.hash);
            }
        }
    }

    triggerLightbox(triggerSelector: string): void {
        $.fancybox.open({
            src: triggerSelector,
            type: 'inline',
        }, {
            baseClass: 'fancybox-no-vertical-padding',
        });
    }

    onComplete(): void {
        $(document).trigger('enhance.zoom');
    }

    // eslint-disable-next-line
    onInit(_e: any, instance: any): void {
        $(document).trigger('enhance.pannellum');
        Helpers.disableScroll();

        setTimeout((): void => {
            if (typeof instance.current !== 'undefined' && instance.current.src === '#salesform') {
                Helpers.disableScroll();
            }

            if ($('.apartment-details__floorplan-svg')) {
                const setActive: string = $('.apartment-details__floorplan-svg').data('current');

                $('.apartment-details__floorplan-svg .floorplan__apt[data-id="' + setActive + '"]').addClass('is-active');
            }
        }, 100);
    }

    beforeClose(): void {
        Helpers.enableScroll();

        if (window.location.hash) {
            history.pushState('', document.title, window.location.pathname + window.location.search);
        }
    }
}

$((): void => {
    new Lightbox();
    $(document).on('click', '[href="#contact-form"]', (event: JQuery.ClickEvent): void => {
        event.preventDefault();
        $('[data-src="#contact-lightbox"]').first().trigger('click');
    });

    $(document).on('click', 'button[data-fancybox-target]', (event: JQuery.ClickEvent): void => {
        event.preventDefault();
        const fancyboxFirstImage: JQuery = $(document).find(`[data-fancybox-first-image]`);

        if (fancyboxFirstImage) {
            fancyboxFirstImage.first().trigger('click');
        }
    });
});
